import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist/utilities'
import {
  StoresTableSearchProps,
  StoresTableSortProps
} from './stores-table-store.types'

export const initialStoresTablePaginationProps: PaginationProps<StoresTableSortProps> = {
  page: 0,
  size: window.innerWidth >= 1920 ? 10 : 6,
  sortDirection: SortDirection.ASC,
  sortProp: StoresTableSortProps.ID,
  totalElements: 0,
  totalPages: 0
}

export const initialStoresTableSearchProps: StoresTableSearchProps = {
  id: null,
  name: '',
  email: '',
  minRating: null,
  maxRating: null,
  minSold: null,
  maxSold: null,
  minRevenue: null,
  maxRevenue: null,
  country: '',
  status: ''
}

export const storesTableNeedTimeoutSearchProps: Array<keyof StoresTableSearchProps> = [
  'id',
  'name',
  'email',
  'country'
]
